import { useTranslation } from 'react-i18next';

import { CountItem } from '../../../CountItem';
import { CoursesPlanificationGraph } from '../CoursesPlanificationGraph';

import {
  CoursesPlanificationWrapper,
  ExpectedSubscriptionsCountWrapper,
  LoadingWrapper
} from './CoursesPlanification.styles';

import { LoadingCircleSpinner } from '@/components/Loaders';
import { useExpectedSubscriptionsOfPlanification } from '@/store';

export const CoursesPlanification = () => {
  const {
    expectedSubscriptionsOfPlanificationForToday,
    lateSubscriptions,
    bitLateSubscriptions,
    onTimeSubscriptions,
    isPending
  } = useExpectedSubscriptionsOfPlanification();
  const { t } = useTranslation('StudentDashboardTranslations');

  return (
    <CoursesPlanificationWrapper>
      {isPending ? (
        <LoadingWrapper>
          <LoadingCircleSpinner />
        </LoadingWrapper>
      ) : (
        <>
          <CoursesPlanificationGraph
            expectedSubscriptionsOfPlanification={
              expectedSubscriptionsOfPlanificationForToday?.expectedSubscriptionsOfPlanification ||
              []
            }
          />
          <ExpectedSubscriptionsCountWrapper>
            <CountItem value={onTimeSubscriptions.length} title={t('ON_TIME')} color="green6" />
            <CountItem value={bitLateSubscriptions.length} title={t('BIT_LATE')} color="orange6" />
            <CountItem value={lateSubscriptions.length} title={t('LATE')} color="red6" />
          </ExpectedSubscriptionsCountWrapper>
        </>
      )}
    </CoursesPlanificationWrapper>
  );
};
